
import { combineReducers } from 'redux'

import authenticate, { AuthenticateState } from './authenticate/authenticate.reducer'
import notification, { NotificationState } from './notification/notification.reducer'
import dataOverview, { DataOverviewState } from './dataOverview/dataOverview.reducer'
import crowdManage, { CrowdManageState } from './crowdManage'
import lbsCircle, { LbsCircleState } from './lbsCircle/lbsCircle.reducer'
import labelConfig, { LabelConfigState } from './labelConfig/labelConfig.reducer'

import labelMarket, { LabelMarketState } from './labelMarket/reducer' 
import labelPublish, { LabelPublishState } from './labelPublish/labelPublish.reducer' 
import combineCrowd, { CombineCrowdState } from './combineCrowd'

//
import { commonReducer, CommonState } from './common/redux'

// import formInfo, { FormInfoState } from './form/form.reducer'
import { FormV4 } from 'components';

import loading from './loading.reducer'

/**
 * root state.x`
 */

declare global {
	interface RootState {
		authenticate: AuthenticateState
		notification: any
		dataOverview: DataOverviewState
		crowdManage: CrowdManageState
		lbsCircle: LbsCircleState
		labelMarket: LabelMarketState
		labelConfig: LabelConfigState
		labelPublish: LabelPublishState
		combineCrowd: CombineCrowdState,
		//
		common: CommonState,
		// formInfo: FormInfoState
	}
}

/**
 * root reducer
 */

const appReducer = combineReducers({
	loading,
	authenticate,
	notification,
	dataOverview,
	crowdManage,
	lbsCircle,
	labelMarket,
	labelConfig,
	labelPublish,
	combineCrowd,
	// 
	common: commonReducer,
	...FormV4.module()
})


// reset redux
// 重置redux，在切换公司或者切换用户的时候需要触发，从而清楚全部缓存数据
// 不要在这里加reset ！！！！
const rootReducer = (state, action) => {
	if (action.type === 'RESET_REDUX') {
		state = undefined
	}
	// 不要在这里加reset ！！！！
	return appReducer(state, action)
}
export default rootReducer
